import authService from "../../services/invoicesService";
import { INVOICES_FETCH_FAILURE, INVOICES_FETCH_REQUEST, INVOICES_FETCH_SUCCESS } from "./actionTypes";
import { INVOICES_ADD_FAILURE, INVOICES_ADD_REQUEST, INVOICES_ADD_SUCCESS } from "./actionTypes";
import { INVOICES_CUSTOMER_ADD_FAILURE, INVOICES_CUSTOMER_ADD_REQUEST, INVOICES_CUSTOMER_ADD_SUCCESS } from "./actionTypes";
import { INVOICES_UPDATE_FAILURE, INVOICES_UPDATE_REQUEST, INVOICES_UPDATE_SUCCESS } from "./actionTypes";
import { INVOICES_CUSTOMER_FETCH_FAILURE, INVOICES_CUSTOMER_FETCH_REQUEST, INVOICES_CUSTOMER_FETCH_SUCCESS } from "./actionTypes";
export const fetchInvoice = (authUserId, page = 1, pageSize = 10,filters) => {
  return async (dispatch) => {
    dispatch({ type: INVOICES_FETCH_REQUEST });
    try {
      const response = await authService.fetchInvoices(authUserId, page, pageSize,filters);

      const  data  = response?.data;
      if (data) {

        dispatch({
          type: INVOICES_FETCH_SUCCESS,
          payload: {
            invoices: data.data, 
            totalInvoices: data.recordsTotal,
          },
        });
        return data; 
      }
    } catch (error) {
      dispatch({
        type: INVOICES_FETCH_FAILURE,
        payload: error.message,
      });
      return Promise.reject(error); 
    }
  };
};
export const addInvoices = (invoicesData) => {
  return async (dispatch) => {
    dispatch({ type: INVOICES_ADD_REQUEST });
    try {
      const response = await authService.addInvoicesApi(invoicesData);
     
      const { data } = response;
      dispatch({ type: INVOICES_ADD_SUCCESS, payload: data });
      return data; 
    } catch (error) {
      dispatch({ type: INVOICES_ADD_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};


export const updateInvoice = (invoicesData) => {
  return async (dispatch) => {
    dispatch({ type: INVOICES_UPDATE_REQUEST });
    try {
      const response = await authService.updateInvoicess(invoicesData);
      const { data } = response;
    
      dispatch({ type: INVOICES_UPDATE_SUCCESS, payload: data });
      return data; 
    } catch (error) {
      dispatch({ type: INVOICES_UPDATE_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};

export const addInvoicesCustomer = (invoicesData) => {
 
  return async (dispatch) => {
    dispatch({ type: INVOICES_CUSTOMER_ADD_REQUEST });
    try {
      const response = await authService.addCustomerInvoicess(invoicesData);
      const { data } = response;
      dispatch({ type: INVOICES_CUSTOMER_ADD_SUCCESS, payload: data });
      fetchInvoiceCustomer();
      return data; 
    } catch (error) {
      dispatch({ type: INVOICES_CUSTOMER_ADD_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};


export const fetchInvoiceCustomer = (authUserId) => {
  return async (dispatch) => {
    dispatch({ type: INVOICES_CUSTOMER_FETCH_REQUEST });
    try {
      const response = await authService.fetchInvoicesCustomer(authUserId);
     
      const data  = response?.data?.data;
      
      dispatch({ type: INVOICES_CUSTOMER_FETCH_SUCCESS, payload: data });
      return data; 
    } catch (error) {
      dispatch({ type: INVOICES_CUSTOMER_FETCH_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};